<a
  [routerLink]="['/products']"
  [queryParams]="{ category: category?.key, page: 1, searchTerm: '' }"
  queryParamsHandling="merge"
  class="atm-category-card">
  <div class="atm-category-card__icon">
    <img
      [alt]="'category-icon-' + category?.label"
      [src]="category?.iconPath" />
  </div>
  <p class="atm-category-card__detail">
    <span style="display: block" class="text-body-medium text-gray-green-900">
      {{ category?.label }}
    </span>
    <span class="text-body text-gray-green-900">{{
      category?.description
    }}</span>
  </p>
</a>
